import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Button } from '@cp/ds/src/components/button';
import { Card, CardProps } from '@cp/ds/src/components/card';
import { Typography } from '@cp/ds/src/components/typography';
import { alpha } from '@mui/system';
import { styled } from '@cp/ds/src/theme';
import { GiftImage } from './gitftImage';

const Root = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: theme.spacing(2.5),
  backgroundColor: alpha(theme.palette.peach, 0.5),
}));

export interface ReferralCardProps extends CardProps {}
export const ReferralCard: React.FC<ReferralCardProps> = ({ onClick, ...props }) => {
  return (
    <Root variant="two" {...props}>
      <Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <GiftImage size={40} />
          <Typography component="div" variant="h3">
            Приведи друга и получи 500₽
          </Typography>
        </Box>
        <Typography component="div" sx={{ color: 'gray', mt: 1, mb: 2.5 }} variant="caption">
          Ваш друг получит в подарок 2 недели, а Вы получите 1 месяц бесплатной подписки за каждого друга.
        </Typography>
      </Box>
      <Button color="pink" onClick={onClick} size="small">
        Пригласить друга
      </Button>
    </Root>
  );
};
